





















































import Vue from "vue";
import Lc from "@/plugins/loginCtl";
import { mapActions, mapState } from "vuex";
import { addAsyncRoute } from "@/router";
export default Vue.extend({
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapState("LoginInfo", ["tenantId", "loading"])
  },
  methods: {
    ...mapActions("LoginInfo", ["login"]),
    formSubmit() {
      this.login(this.loginForm).then(menus => {
        addAsyncRoute(menus);
        Lc.setInfo(true);
        this.$nextTick(() => {
          if ((menus as string[]).includes("MENU_OPERATOR")) {
            this.$router.replace({ name: "Cluster" });
          } else if ((menus as string[]).includes("MENU_ADMIN")) {
            this.$router.replace({ name: "Overview" });
          } else if ((menus as string[]).includes("MENU_TENANT")) {
            this.$router.replace({
              name: "TanOverview",
              params: { tenantId: this.tenantId }
            });
          } else {
            this.$message.error("用户没有菜单权限，请联系管理员");
          }
        });
      });
    },
    toHelp() {
      window.open("/help/index.html", "_black");
    }
  }
});
